import React, { Fragment } from "react";

import { Transition } from "@headlessui/react";
import classNames from "classnames";
import PropTypes from "prop-types";

import Message from "./Message";

function MessageGroup({ author, messages, typing, type }) {
    const isOperator = author?.type === "operator" || author?.type === "agent";

    const indexOfFirstClosed = messages.findIndex(
        (message) => message.content?.type === "closed"
    );

    const messagesBeforeClosed =
        indexOfFirstClosed >= 0
            ? messages.slice(0, indexOfFirstClosed)
            : messages;

    return (
        <Transition
            as="div"
            show
            appear
            className={classNames("ek-chat__message", {
                "ek-chat__message--operator": isOperator,
                "ek-chat__message--visitor": author?.type === "visitor",
                "ek-chat__message--system": type === "system",
            })}
            enterFrom="ek-chat__message--enterFrom"
            enterTo="ek-chat__message--enterTo"
        >
            {isOperator && author?.face && (
                <div className="ek-chat__avatar">
                    <img
                        src={
                            author?.type === "agent"
                                ? `${process.env.REACT_APP_FILE}/files/agents-logo/${author.face}`
                                : `${process.env.REACT_APP_FILE}/files/avatars/${author.face}`
                        }
                        alt=""
                        className="ek-chat__avatar--img"
                    />
                </div>
            )}

            <div>
                {messagesBeforeClosed.map((message, key) => (
                    <Fragment key={message._id}>
                        <Message
                            _id={message._id}
                            author={message.author}
                            content={message.content}
                            status={message.status}
                            type={message.type}
                            first={key === 0}
                            last={key === messages.length - 1}
                            typing={typing}
                            replyTo={message.replyTo}
                            writtenBy={message.writtenBy}
                        />
                    </Fragment>
                ))}
            </div>
        </Transition>
    );
}

MessageGroup.propTypes = {
    /**
     * Type of the message. The type of component returned by Message will depend on this props.
     */
    type: PropTypes.oneOf(["text", "image", "file", "system"]),
    /**
     * messages
     */
    messages: PropTypes.arrayOf(
        PropTypes.shape({
            status: PropTypes.shape({
                error: PropTypes.bool,
            }),
        })
    ),
    /**
     * Author of the message
     */
    author: PropTypes.shape({
        _id: PropTypes.string,
        type: PropTypes.oneOf(["operator", "supervisor", "visitor", "agent"]),
        name: PropTypes.string,
        face: PropTypes.string,
    }),
    /**
     * Status of the message
     */
    status: PropTypes.shape({
        success: PropTypes.bool,
        error: PropTypes.bool,
        sentAt: PropTypes.string,
        receivedAt: PropTypes.string,
        readAt: PropTypes.string,
    }),
    /**
     * Typing Mode
     */
    typing: PropTypes.bool,
};

MessageGroup.defaultProps = {
    type: "text",
    messages: [],
    author: {},
    status: {},
    typing: false,
};

export default MessageGroup;
